// src/components/forgot/Forgot.jsx
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Forgot.css";
import { requestForgotOtpApi, resetPasswordWithOtpApi } from "../../services/forgot";

export default function Forgot() {
  const nav = useNavigate();

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const digits = useMemo(() => mobile.replace(/\D+/g, ""), [mobile]);

  const requestOtp = async () => {
    setMsg("");
    if (digits.length !== 10) {
      setMsg("Enter valid 10 digit mobile number.");
      return;
    }

    setLoading(true);
    try {
      const res = await requestForgotOtpApi(digits);
      if (!res?.ok) {
        setMsg(res?.error || "Failed to send OTP. Please try again.");
      } else {
        setOtpSent(true);
        setMsg("OTP sent successfully.");
      }
    } catch (e) {
      console.error("requestForgotOtpApi error", e);
      setMsg("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const submit = async () => {
    setMsg("");

    if (!otpSent) {
      setMsg("Please request OTP first.");
      return;
    }
    if (digits.length !== 10 || !otp.trim() || !newPass.trim() || !confirmPass.trim()) {
      setMsg("Please fill all fields.");
      return;
    }
    if (newPass !== confirmPass) {
      setMsg("Password and Confirm Password must match.");
      return;
    }
    if (newPass.length < 4) {
      setMsg("Password too short (min 4 characters).");
      return;
    }

    setLoading(true);
    try {
      const res = await resetPasswordWithOtpApi(digits, otp, newPass);
      if (!res?.ok) {
        setMsg(res?.error || "Failed to change password. Please try again.");
      } else {
        alert("Password changed successfully. Please login.");
        nav("/"); // go back to login
      }
    } catch (e) {
      console.error("resetPasswordWithOtpApi error", e);
      setMsg("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgotPage">
      <div className="forgotCard">
        <div className="forgotHeader">
          <div className="forgotTitle">Forgot Password</div>
          <div className="forgotSub">Reset your password using OTP</div>
        </div>

        <div className="forgotForm">
          <label className="fLabel">Mobile Number</label>
          <input
            className="fInput"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter 10 digit mobile"
            maxLength={14}
            inputMode="numeric"
          />

          <div className="fRow">
            <button
              className="fBtn fBtnDark"
              type="button"
              onClick={requestOtp}
              disabled={loading || digits.length !== 10}
            >
              {loading ? "Please wait..." : "Send OTP"}
            </button>

            <button
              className="fBtn"
              type="button"
              onClick={() => nav("/")}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>

          <div className={`otpSection ${otpSent ? "enabled" : "disabled"}`}>
            <label className="fLabel">OTP</label>
            <input
              className="fInput"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              inputMode="numeric"
              disabled={!otpSent || loading}
            />

            <label className="fLabel">New Password</label>
            <input
              className="fInput"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
              placeholder="New Password"
              type="password"
              disabled={!otpSent || loading}
            />

            <label className="fLabel">Confirm Password</label>
            <input
              className="fInput"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
              placeholder="Confirm Password"
              type="password"
              disabled={!otpSent || loading}
            />

            <button
              className="fBtn fBtnDark full"
              type="button"
              onClick={submit}
              disabled={!otpSent || loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>

          {msg ? <div className="fMsg">{msg}</div> : null}
        </div>
      </div>
    </div>
  );
}
